import { render, staticRenderFns } from "./MultiSelectV2.vue?vue&type=template&id=67835db5&"
import script from "./MultiSelectV2.vue?vue&type=script&lang=js&"
export * from "./MultiSelectV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports